<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>

        <div class="box">
          <admin-box-item title="배송비조건">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="배송비조건명">
                  <input class="input"
                         :value="value.name"
                         @input="e => value.name = e.target.value"
                         type="text">
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="배송비조건 설명">
                  <input class="input"
                         :value="value.desc"
                         @input="e => value.desc = e.target.value"
                         type="text">
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="배송 방식">
                  <lp-check-group :list="deliveryMethodArr"
                                  :data="value.delivery_method"
                                  @check="initializeDeliveryPriceSetting"
                                  value_name="value"
                                  label_name="label"></lp-check-group>
                  <!--<lp-radio :val="value.delivery_method"
                            value_name="value"
                            label_name="label"
                            :data="deliveryMethodArr"
                            @onSelect="val=>selectType('delivery_method',val)"></lp-radio>-->
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="배송비 유형">
                  <lp-radio :val="value.delivery_type"
                            value_name="value"
                            label_name="label"
                            :data="deliveryTypeArr"
                            @onSelect="val=>selectType('delivery_type',val)"></lp-radio>
                </admin-form-item>
              </div>

              <div class="column is-full" v-if="value.delivery_method.length > 1">
                <admin-form-item label="배송비 설정방법">
                  <lp-radio :val="value.delivery_setting_method"
                            value_name="value"
                            label_name="label"
                            :data="deliverySettingMethodArr"
                            @onSelect="val=>selectType('delivery_setting_method',val)"></lp-radio>
                </admin-form-item>
              </div>

              <div class="column is-full" v-if="value.delivery_type===0">
                <admin-form-item label="배송비 설정">
                  <!-- 고정배송비 일괄 설정 -->
                  <div class="flex" v-if="value.delivery_setting_method===0">
                    <div style="width:100px">고정배송비 금액</div>
                    <div>
                      <input class="input full has-text-right"
                             v-model="value.fix_price"
                             @input="e => setNumber(e, 'fix_price', 10)"
                             type="number">
                    </div>
                  </div>
                  <!-- 고정배송비 개별 설정 -->
                  <div v-if="value.delivery_setting_method===1">
                    <div class="flex" v-for="(val, key) in value.delivery_price_setting" :key="'dp-setting-'+key">
                      <div style="width:100px">
                        <span v-if="key==='parcel_price'">택배</span>
                        <span v-else-if="key==='post_price'">등기,소포</span>
                        <span v-else-if="key==='cargo_price'">화물배송</span>
                        <span v-else-if="key==='visit_price'">방문수령</span>
                        <span v-else-if="key==='quick_price'">퀵배송</span>
                      </div>
                      <div>
                        <input class="input full has-text-right"
                               :value="val"
                               @input="e=>setFixPrice(key, e)"
                               type="number">
                      </div>
                    </div>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-full" v-if="value.delivery_type===2 || value.delivery_type===3 || value.delivery_type===4">
                <admin-form-item label="배송비 설정">
                  <table>
                    <thead style="padding:12px;background-color:#eee">
                      <tr>
                        <td style="text-align: center">구매수량 범위</td>
                        <!-- 일괄설정 -->
                        <td v-if="value.delivery_setting_method===0">배송비</td>
                        <!-- 개별설정 -->
                        <td style="width:120px;text-align: center" v-if="isDeliverySettingMethod('parcel')">택배</td>
                        <td style="width:120px;text-align: center" v-if="isDeliverySettingMethod('post')">등기,소포</td>
                        <td style="width:120px;text-align: center" v-if="isDeliverySettingMethod('cargo')">화물배송</td>
                        <td style="width:120px;text-align: center" v-if="isDeliverySettingMethod('visit')">방문수령</td>
                        <td style="width:120px;text-align: center" v-if="isDeliverySettingMethod('quick')">퀵배송</td>
                        <td style="width:120px;text-align: center"></td>
                      </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, idx) in value.delivery_price_setting"
                         :key="'dp-'+idx"
                         style="padding:12px 0;border-bottom:1px solid #eee">
                      <td>
                        <div style="flex-wrap:wrap" class="flex align-center">
                          <input class="input"
                                 style="width:120px"
                                 v-model="item.min"
                                 type="number"
                                 readonly>
                          <span style="margin:0 4px">
                          <span v-if="value.delivery_type===2">원</span>
                          <span v-if="value.delivery_type===3">개</span>
                          <span v-if="value.delivery_type===4">g</span>
                          이상 ~</span>
                          <input class="input"
                                 style="width:120px"
                                 v-model="item.max"
                                 @input="e => setMax(e, item, idx)"
                                 type="number"
                                 v-if="idx<value.delivery_price_setting.length-1">
                          <span style="margin-left:4px" v-if="idx<value.delivery_price_setting.length-1">
                          <span v-if="value.delivery_type===2">원</span>
                          <span v-if="value.delivery_type===3">개</span>
                          <span v-if="value.delivery_type===4">g</span>
                          미만일 때</span>
                        </div>
                      </td>
                      <td v-if="value.delivery_setting_method===0">
                        <input class="input"
                               v-model="item.price"
                               @input="e => setPrice(e, item, 'price')"
                               type="number">
                      </td>
                      <td v-if="isDeliverySettingMethod('parcel')&&value.delivery_setting_method===1">
                        <input class="input"
                               v-model="item.parcel_price"
                               @input="e => setPrice(e, item, 'parcel_price')"
                               type="number">
                      </td>
                      <td v-if="isDeliverySettingMethod('post')&&value.delivery_setting_method===1">
                        <input class="input"
                               v-model="item.post_price"
                               @input="e => setPrice(e, item, 'post_price')"
                               type="number">
                      </td>
                      <td v-if="isDeliverySettingMethod('cargo')&&value.delivery_setting_method===1">
                        <input class="input"
                               v-model="item.cargo_price"
                               @input="e => setPrice(e, item, 'cargo_price')"
                               type="number">
                      </td>
                      <td v-if="isDeliverySettingMethod('visit')&&value.delivery_setting_method===1">
                        <input class="input"
                               v-model="item.visit_price"
                               @input="e => setPrice(e, item, 'visit_price')"
                               type="number">
                      </td>
                      <td v-if="isDeliverySettingMethod('quick')&&value.delivery_setting_method===1">
                        <input class="input"
                               v-model="item.quick_price"
                               @input="e => setPrice(e, item, 'quick_price')"
                               type="number">
                      </td>
                      <td>
                        <button class="button half"
                                v-if="idx===0" @click="addDeliveryPriceSetting">+추가</button>
                        <button class="button half"
                                @click="deleteDeliveryPriceSetting(idx)"
                                v-else-if="idx>=1 && idx<value.delivery_price_setting.length-1">-삭제</button>
                        <div v-else-if="idx===value.delivery_price_setting.length-1"></div>
                      </td>
                    </tr>
                    </tbody>

                  </table>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="배송비 부과 방법">
                  <lp-radio :val="value.tax_method"
                            value_name="value"
                            label_name="label"
                            :data="taxMethodArr"
                            @onSelect="val=>selectType('tax_method',val)"></lp-radio>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="배송비 결제 방법">
                  <lp-radio :val="value.pay_type"
                            value_name="value"
                            label_name="label"
                            :data="payTypeArr"
                            @onSelect="val=>selectType('pay_type',val)"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <div v-if="!base_condition">
                  <lp-check-bool :checkedVal.sync="value.is_base"
                                 label="상품등록 시 기본으로 노출되도록 설정합니다."></lp-check-bool>
                </div>
                <div v-else>상품등록 시 기본으로 노출되도록 설정</div>
              </div>
            </div>

          </admin-box-item>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../../module/common/LpRadio";
  import LpCheckGroup from "../../module/common/LpCheckGroup";
  import LpCheckBool from "../../module/common/LpCheckBool";

  export default {
    components: {
      LpCheckBool,
      LpCheckGroup,
      LpRadio},
    name: "delivery-price-create",
    data() {
      return {
        partner_id: 0,
        value: {
          name: '',
          desc: '',
          delivery_method: ['parcel',], // 배송비 방식
          delivery_type: 0, // 배송비 유형 ( 고정배송비, 배송비무료, 금액별, 수량별, 무게별 )
          delivery_setting_method: 0, // 배송비 설정 방법(0: 배송 방식에 상관 없이 일괄설정, 1: 배송 방식별 개별 설정)
          fix_price: 0,   // 고정배송비
          tax_method: 0,  // 배송비 부과방법 ( 배송비조건별, 상품별 )
          one_tax: false, // 상품별 선택시 동일 상품일 경우 1회만 부과 사용여부
          pay_type: 0, // 배송비 결제 방법 ( 선불, 착불, 선불/착불 선택 )
          delivery_price_setting: [],  // 배송비 설정,
          is_base: false    // 기본 설정
        },
        base_condition: false,
        deliveryMethodArr: [
          {label:'택배',value:'parcel'},
          {label:'등기/소포',value:'post'},
          {label:'화물배송',value:'cargo'},
          {label:'방문수령',value:'visit'},
          {label:'퀵배송',value:'quick'}
        ],
        deliveryTypeArr: [
          {label:'고정배송비',value:0},
          {label:'배송비무료',value:1},
          {label:'금액별',value:2},
          {label:'수량별',value:3},
          /*{label:'무게별',value:4}*/
        ],
        // 배송비 설정 방법
        deliverySettingMethodArr: [
          {label:'배송 방식에 상관없이 일괄설정', value: 0},
          {label:'배송 방식별 개별설정', value:1}
        ],
        taxMethodArr: [
          {label:'배송비조건별',value:0},
          // {label:'상품별',value:1}
        ],
        payTypeArr: [
          {label:'선불',value:0},
          /*{label:'착불',value:1},
          {label:'선불/착불',value:2}*/
        ]
      }
    },
    created() {
      this.getData();
      this.initPartner();
    },
    methods: {
      initPartner() {
        if(!this.isAdmin) {
          this.partner_id = this.$store.getters.partner.partner_id;
        }
      },
      setFixPrice(key, e) {
        this.value.delivery_price_setting[key] = parseInt(e.target.value);
      },
      // 배송비 방식 선택했을 경우
      isDeliverySettingMethod(type) {
        // 일괄
        if(this.value.delivery_setting_method===0) return false;
        // 개별
        else {
          return this.value.delivery_method.indexOf(type) > -1
        }
      },
      // 배송비 설정 추가
      addDeliveryPriceSetting() {
        let len = this.value.delivery_price_setting.length;

        // 일괄 배송 방식
        if(this.value.delivery_setting_method===0) {
          this.value.delivery_price_setting.splice(len-1, 0, {min: 0, max: '', price: 0})
        }
        // 개별 배송 방식
        else {
          this.value.delivery_price_setting.splice(len-1, 0, {min: 0, max: '', price: 0})
          this.value.delivery_method.forEach(item=> {
            let field = item + '_price';
            this.value.delivery_price_setting[len-1][field] = 0;
          })
        }
      },
      // 배송비 설정 삭제
      deleteDeliveryPriceSetting(idx) {
        removeIndex(this.value.delivery_price_setting,idx);
      },
      getData() {
        if(this.$route.query.id) {
          this.$axios.get(this.getUrl(`product/deliveryprice/${this.$route.query.id}`)).then(res=> {
            this.value = res.data;
            this.base_condition = res.data.is_base;
          })
        }
      },
      // 유형 선택
      selectType(key, value) {
        this.value[key] = value;
        console.log(key, value)
        this.initializeDeliveryPriceSetting();
      },
      // 배송비 설정값 초기화
      initializeDeliveryPriceSetting() {
        // 배송방식이 없을 경우 배송비 설정 방법은 일괄설정으로 변경
        if(this.value.delivery_method.length===0) {
          this.value.delivery_setting_method = 0;
        }
        // 배송비 설정 방법이 일괄 설정일 경우
        if(this.value.delivery_setting_method===0) {
          this.value.delivery_price_setting = [
            {min: 0, max: 0, price: 0},
            {min: 0, max: 0, price: 0}
          ]
          //console.log('일괄')
        }
        // 배송비 설정 방법이 개별 설정이면서 배송비 유형이 금액별, 수량별, 무게별일 경우
        else if(this.value.delivery_setting_method===1
          && (this.value.delivery_type===2
          || this.value.delivery_type===3
          || this.value.delivery_type===4)){
          //console.log('개별')
          this.value.delivery_price_setting = [
            {min: 0, max: 0},
            {min: 0, max: 0}
          ]

          this.value.delivery_method.forEach(item=> {
            let field = item + '_price';
            this.value.delivery_price_setting.forEach(item2=>{
              item2[field] = 0;
            })
          })
        }
        // 배송비 설정 방법이 개별 설정이면서 배송비 유형이 고정 배송비
        else if(this.value.delivery_setting_method===1
          && this.value.delivery_type===0) {
          let value = {};
          this.value.delivery_method.forEach(item=> {
            let field = item + '_price';
            value[field] = 0;
            console.log('배송비 설정 방법이 개별 설정이면서 배송비 유형이 고정 배송비', value)
          })
          this.value.delivery_price_setting = value;
        }

      },
      // 배송비
      setPrice(e, item, type) {
        item[type] = parseInt(e.target.value.substr(0, 10));
      },
      // 배송비 설정
      setMax(e, item, idx) {
        item.max = parseInt(e.target.value.substr(0, 10));
        this.value.delivery_price_setting[idx+1].min = parseInt(e.target.value.substr(0, 10));
      },
      // 숫자 입력
      setNumber(e, key, max_length) {
        if(e.target.value.length > max_length) this.value[key] = parseInt(e.target.value.substr(0, max_length));
        else this.value[key] = parseInt(e.target.value);
      },
      // 수량별, 금액별, 무게별 값 입력이 잘 되어있는지 확인
      checkDeliveryType() {
        let items = this.value.delivery_price_setting;
        let min = 0;
        let max = 0;
        for(let i = 0; i<items.length; i++) {
          min = parseInt(items[i].min);
          max = parseInt(items[i].max);
          // list의 마지막은 통과
          if(i===items.length-1) continue;
          // 이전 최대값과 현재 최소값이 같이 않을 경우 false
          if(i>0) {
            if(parseInt(items[i-1].max)!==min) {
              return false;
            }
          }
          // 최대값이 최소값 이상일 경우 continue
          if(min <= max) continue;
          else return false;
        }
        return true;
      },
      saveData() {
        if(this.checkDeliveryType()===false) {
          this.toast('범위가 잘못 되었습니다. 올바르게 입력해주세요.');
          return;
        }
        if(this.value.name==='') {
          this.toast('조건명을 입력하세요.');
          return;
        }
        let value = this.cloneItem(this.value);
        if(!this.isAdmin) {
          value.partner_id = this.partner_id;
        }
        if(this.$route.query.id) {
          this.$axios.patch(this.getUrl(`product/deliveryprice/${this.$route.query.id}`), value).then(res=> {
            if(res.status===200) {
              this.toast('배송비조건이 수정되었습니다.');
              this.$router.replace(this.getPath('deliveryprice'));
            }
          })
        }
        else {
          this.$axios.post(this.getUrl(`product/deliveryprice`), value).then(res=> {
            if(res.status===200) {
              this.toast('배송비조건이 등록되었습니다.');
              this.$router.replace(this.getPath('deliveryprice'));
            }
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
